import { DynamicObject } from "@/types/generic";
import { fexPut } from "@/utils/fex";



export const changeLayoutElementFields = async ({elementId,fields}:{elementId:string,fields:DynamicObject})=>{
    const res = await fexPut("api/layout-element/"+elementId,fields)
}